import { render, staticRenderFns } from "./RenameVariable.vue?vue&type=template&id=6df7c126"
import script from "./RenameVariable.vue?vue&type=script&lang=js"
export * from "./RenameVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports